"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAccountDeletionRequestResponseDto = instanceOfAccountDeletionRequestResponseDto;
exports.AccountDeletionRequestResponseDtoFromJSON = AccountDeletionRequestResponseDtoFromJSON;
exports.AccountDeletionRequestResponseDtoFromJSONTyped = AccountDeletionRequestResponseDtoFromJSONTyped;
exports.AccountDeletionRequestResponseDtoToJSON = AccountDeletionRequestResponseDtoToJSON;
exports.AccountDeletionRequestResponseDtoToJSONTyped = AccountDeletionRequestResponseDtoToJSONTyped;
var AccountDeletionRequestDataDto_1 = require("./AccountDeletionRequestDataDto");
/**
 * Check if a given object implements the AccountDeletionRequestResponseDto interface.
 */
function instanceOfAccountDeletionRequestResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function AccountDeletionRequestResponseDtoFromJSON(json) {
    return AccountDeletionRequestResponseDtoFromJSONTyped(json, false);
}
function AccountDeletionRequestResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, AccountDeletionRequestDataDto_1.AccountDeletionRequestDataDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function AccountDeletionRequestResponseDtoToJSON(json) {
    return AccountDeletionRequestResponseDtoToJSONTyped(json, false);
}
function AccountDeletionRequestResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, AccountDeletionRequestDataDto_1.AccountDeletionRequestDataDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
